import { ServiceRequest } from "@medplum/fhirtypes";

import { TextWrapper } from "@/components/TextWrapper";
import { getUploadedImagingTitle } from "@/health-gorilla/utils/labs";

interface LabOrderNameProps {
  labOrder: ServiceRequest;
}

/** The tests or studies an order is for, with an uploaded imaging result's title beneath them. */
export default function LabOrderName({ labOrder }: LabOrderNameProps) {
  const name = labOrder.code?.coding?.map((coding) => coding.display).join(", ") || "--";
  const title = getUploadedImagingTitle(labOrder);

  return (
    <>
      {name}
      {title && (
        <TextWrapper size="sm" c="gray.6">
          {title}
        </TextWrapper>
      )}
    </>
  );
}
